exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center-content {\n\ttext-align: center;\n}\n\n.image-holder{\n\t/* background-image: url(\"https://www.thermofisher.com/order/catalog/en/US/images/image-na.png\"); */\n\tbackground-size: cover;\n\tmax-width:180px;\n\n}\n\n.img-responsive {\n\tdisplay:block;\n\tposition:relative;\n\twidth:100%;\n\theight:auto;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/thomas.obrien2/projects/nalgene/src/app/categories/categories.component.css
// module id = ../../../../../src/app/categories/categories.component.css
// module chunks = main